import { render, staticRenderFns } from "./merchantAddressEdit.vue?vue&type=template&id=72916259&scoped=true&"
import script from "./merchantAddressEdit.vue?vue&type=script&lang=js&"
export * from "./merchantAddressEdit.vue?vue&type=script&lang=js&"
import style0 from "./merchantAddressEdit.vue?vue&type=style&index=0&id=72916259&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72916259",
  null
  
)

export default component.exports